import { camelCase } from 'lodash';

export class StringTransformHelper {
  static toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }

  static toCamelCase(str: string): string {
    return camelCase(str);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/string-transform.helper.ts